import { useState } from "react";
import { SearchableSelect } from "@/components/shared/SearchableSelect";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Site OR Equipment — exactly one, on every Payment Desk record (bills and
// payment lines alike). A single "Attributed To" type toggle then one
// dropdown keeps the "exactly one" rule impossible to violate from the UI.
export function AttributionField({ siteId, equipmentId, sites, equipment, onChange, testId, sitesLoading, equipmentLoading }) {
  const [mode, setMode] = useState(equipmentId ? "equipment" : "site");

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="text-sm font-medium text-slate-700 mb-1.5 block">Attributed To *</label>
        <Select value={mode} onValueChange={(v) => { setMode(v); onChange(v === "site" ? { siteId: siteId || "", equipmentId: "" } : { siteId: "", equipmentId: equipmentId || "" }); }}>
          <SelectTrigger data-testid={`${testId}-mode-select`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="site">Site</SelectItem>
            <SelectItem value="equipment">Equipment</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <label className="text-sm font-medium text-slate-700 mb-1.5 block">{mode === "site" ? "Site *" : "Equipment *"}</label>
        {mode === "site" ? (
          <SearchableSelect testId={`${testId}-site-select`} loading={sitesLoading} value={siteId || ""} onValueChange={(v) => onChange({ siteId: v, equipmentId: "" })} placeholder="Select site"
  options={sites.map((s) => ({ value: s.site_id, label: s.display_label || s.label, testId: `${testId}-site-option-${s.site_id}` }))} />
        ) : (
          <SearchableSelect testId={`${testId}-equipment-select`} loading={equipmentLoading} value={equipmentId || ""} onValueChange={(v) => onChange({ siteId: "", equipmentId: v })} placeholder="Select equipment"
  options={equipment.map((a) => ({ value: a.asset_id, label: a.label, testId: `${testId}-equipment-option-${a.asset_id}` }))} />
        )}
      </div>
    </div>
  );
}
